import { Component, EventEmitter, Output, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Observable, of, zip } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { UserService } from 'src/app/user/user.service';

@Component({
  selector: 'app-sign-up-user',
  templateUrl: './sign-up-user.component.html',
  styleUrls: ['./sign-up-user.component.scss'],
  standalone: false
})
export class SignUpUserComponent {
  private user = inject(UserService);

  signUpForm = new FormGroup({
    user: new FormControl('', [
      Validators.required,
      Validators.minLength(6),
      Validators.maxLength(255),
      Validators.pattern('[a-z0-9._]*')
    ]),
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [Validators.required, Validators.minLength(6)]),
    confirmPassword: new FormControl('', [Validators.required])
  });

  userError?: string;
  emailError?: string;
  passwordError?: string;
  confirmPasswordError?: string;

  @Output() goBack = new EventEmitter<boolean>();
  @Output() submit = new EventEmitter<string[]>();
  @Output() isLoading = new EventEmitter<boolean>();

  get signUp() {
    return this.signUpForm.controls;
  }

  checkUserError(): Observable<string> {
    const username = this.signUpForm.get('user').value;
    if (this.signUp['user'].errors) {
      return of('ชื่อผู้ใช้มีความยาว 6-255 ตัวอักษร ( a-z 0-9 _ . )');
    }
    return this.user.check(username, '').pipe(
      mergeMap((availability) => {
        if (!availability.usernameAvailable) {
          return of('ชื่อผู้ใช้มีผู้ใช้งานแล้ว');
        }
        return of('');
      })
    );
  }

  checkEmailError(): Observable<string> {
    const email = this.signUpForm.get('email').value;
    if (this.signUp['email'].errors) {
      return of('กรุณาระบุอีเมลให้ถูกต้อง');
    }
    return this.user.check('', email).pipe(
      mergeMap((availability) => {
        if (!availability.emailAvailable) {
          return of('อีเมลนี้มีผู้ใช้งานแล้ว');
        }
        return of('');
      })
    );
  }

  checkPasswordError(): Observable<string> {
    if (this.signUp['password'].errors) {
      return of('รหัสผ่านมีความยาวอย่างน้อย 6 ตัวอักษร');
    }
    return of('');
  }

  checkConfirmPasswordError(): Observable<string> {
    const password = this.signUpForm.get('password').value;
    const confirmPassword = this.signUpForm.get('confirmPassword').value;
    if (this.signUp['confirmPassword'].errors) {
      return of('กรุณายืนยันรหัสผ่าน');
    }
    if (password !== confirmPassword) {
      this.signUpForm.get('confirmPassword').setValue('');
      return of('รหัสผ่านไม่ตรงกัน');
    }
    return of('');
  }

  goBackFunc() {
    this.goBack.emit(true);
  }

  doSignUp() {
    this.userError = undefined;
    this.emailError = undefined;
    this.passwordError = undefined;
    this.confirmPasswordError = undefined;
    this.isLoading.emit(true);

    const response = zip(
      this.checkUserError(),
      this.checkEmailError(),
      this.checkPasswordError(),
      this.checkConfirmPasswordError()
    );

    response.subscribe((val) => {
      this.isLoading.emit(false);
      const [userErrorRes, emailErrorRes, passwordErrorRes, confirmPasswordErrorRes] = val;
      this.userError = userErrorRes;
      this.emailError = emailErrorRes;
      this.passwordError = passwordErrorRes;
      this.confirmPasswordError = confirmPasswordErrorRes;
      if (
        !this.userError &&
        !this.emailError &&
        !this.passwordError &&
        !this.confirmPasswordError
      ) {
        const username = this.signUpForm.get('user').value;
        const email = this.signUpForm.get('email').value;
        const password = this.signUpForm.get('password').value;
        this.submit.emit([username, email, password]);
      }
    });
  }
}
